import tinycolor from 'tinycolor2';

export default {

    name: "colorMixin",

    methods: {

        getFontClasses(backgroundColor) {

            const lighten = [
                //{hex: '#BDBDBD', class: 'text--lighten-1'},
                {hex: '#E0E0E0', class: 'text--lighten-2'},
                {hex: '#EEEEEE', class: 'text--lighten-3'},
                {hex: '#F5F5F5', class: 'text--lighten-4'}
            ];

            const darken = [
                //{hex: '#757575', class: 'text--darken-1'},
                {hex: '#616161', class: 'text--darken-2'},
                {hex: '#424242', class: 'text--darken-3'},
                {hex: '#212121', class: 'text--darken-4'}
            ];

            const greyBrightness = tinycolor('#9E9E9E').getBrightness()
            const backgroundBrightness = tinycolor(backgroundColor).getBrightness()

            //const contrast = tinycolor.readability(backgroundColor, '#9E9E9E');

            let firstReadableColor = null;

            // Dark color back ground
            if (backgroundBrightness < greyBrightness) {
                firstReadableColor = lighten.find(color => {
                    return tinycolor.isReadable(backgroundColor, color.hex);
                });

                if (!firstReadableColor) firstReadableColor = {class: 'text--lighten-4'};
            } else {
                firstReadableColor = darken.find(color => {
                    return tinycolor.isReadable(backgroundColor, color.hex);
                });
                if (!firstReadableColor) firstReadableColor = {class: 'text--darken-4'};
            }

            return ['grey--text', firstReadableColor.class].join(' ');
        },

        lighten(color) {
            return tinycolor(color).lighten().toString();
        },

        darken(color) {
            return tinycolor(color).darken().toString();
        },

        isDarkColor(color) {
            return tinycolor(color).isDark();
        },

        getRgbaColor(color) {
            const comp = tinycolor(color).toRgb();
            return 'rgba(' + comp.r + ',' + comp.g + ',' + comp.b + ',1)';
        },

        getForegroundFromBackground(background) {
            const bgColor = tinycolor(background);
            const fgColor = bgColor.clone();

            const bgLuminance = Math.round(bgColor.getLuminance() * 100);

            if (bgColor.isDark()) {
                fgColor.lighten(bgLuminance);
            } else {
                fgColor.darken(bgLuminance);
            }

            return tinycolor.mostReadable(bgColor, [fgColor], {
                includeFallbackColors: true,
                level: 'AAA',
                size: 'small'
            }).toHexString();
        },
    }
}

